export const stateCenter = {
  AL: {
    'Province/State': 'Alabama',
    StateCode: 'AL',
    Latitude: 32.6182,
    Longitude: -86.9023,
    scale: 5000,
  },
  AK: {
    'Province/State': 'Alaska',
    StateCode: 'AK',
    Latitude: 61.3707,
    Longitude: -152.4044,
    rotate: [150, -10],
    scale: 1500,
  },
  AZ: {
    'Province/State': 'Arizona',
    StateCode: 'AZ',
    Latitude: 34.2298,
    Longitude: -111.4312,
  },
  AR: {
    'Province/State': 'Arkansas',
    StateCode: 'AR',
    Latitude: 34.7697,
    Longitude: -92.3731,
    scale: 6000,
  },
  CA: {
    'Province/State': 'California',
    StateCode: 'CA',
    Latitude: 37.3562,
    Longitude: -119.6816,
    scale: 2500,
  },
  CO: {
    'Province/State': 'Colorado',
    StateCode: 'CO',
    Latitude: 39.0598,
    Longitude: -105.5511,
    scale: 5000,
  },
  CT: {
    'Province/State': 'Connecticut',
    StateCode: 'CT',
    Latitude: 41.5178,
    Longitude: -72.7554,
    scale: 17000,
  },
  DE: {
    'Province/State': 'Delaware',
    StateCode: 'DE',
    Latitude: 39.1585,
    Longitude: -75.5071,
    scale: 15000,
  },
  DC: {
    'Province/State': 'District of Columbia',
    StateCode: 'DC',
    Latitude: 38.8974,
    Longitude: -77.0268,
  },
  FL: {
    'Province/State': 'Florida',
    StateCode: 'FL',
    Latitude: 27.7663,
    Longitude: -83.6868,
  },
  GA: {
    'Province/State': 'Georgia',
    StateCode: 'GA',
    Latitude: 32.7406,
    Longitude: -83.6431,
    scale: 6000,
  },
  GU: {
    'Province/State': 'Guam',
    StateCode: 'GU',
    Latitude: 13.4443,
    Longitude: 144.7937,
  },
  HI: {
    'Province/State': 'Hawaii',
    StateCode: 'HI',
    Latitude: 20.5943,
    Longitude: -157.4983,
    scale: 6000,
  },
  ID: {
    'Province/State': 'Idaho',
    StateCode: 'ID',
    Latitude: 45.5205,
    Longitude: -114.4788,
    scale: 3000,
  },
  IL: {
    'Province/State': 'Illinois',
    StateCode: 'IL',
    Latitude: 39.7495,
    Longitude: -88.9861,
    scale: 4200,
  },
  IN: {
    'Province/State': 'Indiana',
    StateCode: 'IN',
    Latitude: 39.8494,
    Longitude: -86.2583,
    scale: 5500,
  },
  IA: {
    'Province/State': 'Iowa',
    StateCode: 'IA',
    Latitude: 42.0115,
    Longitude: -93.4105,
    scale: 6000,
  },
  KS: {
    'Province/State': 'Kansas',
    StateCode: 'KS',
    Latitude: 38.5266,
    Longitude: -98.4265,
    scale: 5300,
  },
  KY: {
    'Province/State': 'Kentucky',
    StateCode: 'KY',
    Latitude: 37.6681,
    Longitude: -85.6701,
    scale: 5400,
  },
  LA: {
    'Province/State': 'Louisiana',
    StateCode: 'LA',
    Latitude: 30.995,
    Longitude: -91.8678,
    scale: 5800,
  },
  ME: {
    'Province/State': 'Maine',
    StateCode: 'ME',
    Latitude: 45.3039,
    Longitude: -69.3819,
    scale: 4800,
  },
  MD: {
    'Province/State': 'Maryland',
    StateCode: 'MD',
    Latitude: 39.0639,
    Longitude: -77.3021,
    scale: 8300,
  },
  MA: {
    'Province/State': 'Massachusetts',
    StateCode: 'MA',
    Latitude: 42.0302,
    Longitude: -71.7301,
    scale: 11000,
  },
  MI: {
    'Province/State': 'Michigan',
    StateCode: 'MI',
    Latitude: 44.7266,
    Longitude: -86.5361,
  },
  MN: {
    'Province/State': 'Minnesota',
    StateCode: 'MN',
    Latitude: 46.4245,
    Longitude: -93.9002,
    scale: 3500,
  },
  MS: {
    'Province/State': 'Mississippi',
    StateCode: 'MS',
    Latitude: 32.7416,
    Longitude: -89.6787,
    scale: 5000,
  },
  MO: {
    'Province/State': 'Missouri',
    StateCode: 'MO',
    Latitude: 38.4561,
    Longitude: -92.2884,
    scale: 5000,
  },
  MT: {
    'Province/State': 'Montana',
    StateCode: 'MT',
    Latitude: 46.9219,
    Longitude: -110.4544,
    scale: 3000,
  },
  NE: {
    'Province/State': 'Nebraska',
    StateCode: 'NE',
    Latitude: 41.5254,
    Longitude: -99.6681,
    scale: 4800,
  },
  NV: {
    'Province/State': 'Nevada',
    StateCode: 'NV',
    Latitude: 38.5135,
    Longitude: -117.0554,
    scale: 3400,
  },
  NH: {
    'Province/State': 'New Hampshire',
    StateCode: 'NH',
    Latitude: 43.9525,
    Longitude: -71.5639,
    scale: 8000,
  },
  NJ: {
    'Province/State': 'New Jersey',
    StateCode: 'NJ',
    Latitude: 40.0989,
    Longitude: -74.521,
    scale: 9600,
  },
  NM: {
    'Province/State': 'New Mexico',
    StateCode: 'NM',
    Latitude: 34.1905,
    Longitude: -106.2485,
  },
  NY: {
    'Province/State': 'New York',
    StateCode: 'NY',
    Latitude: 42.7657,
    Longitude: -75.7481,
    scale: 4800,
  },
  NC: {
    'Province/State': 'North Carolina',
    StateCode: 'NC',
    Latitude: 35.6301,
    Longitude: -79.8064,
    scale: 4700,
  },
  ND: {
    'Province/State': 'North Dakota',
    StateCode: 'ND',
    Latitude: 47.5289,
    Longitude: -100.384,
    scale: 5000,
  },
  OH: {
    'Province/State': 'Ohio',
    StateCode: 'OH',
    Latitude: 40.1888,
    Longitude: -82.7649,
    scale: 6000,
  },
  OK: {
    'Province/State': 'Oklahoma',
    StateCode: 'OK',
    Latitude: 35.5653,
    Longitude: -98.6289,
    scale: 4600,
  },
  OR: {
    'Province/State': 'Oregon',
    StateCode: 'OR',
    Latitude: 44.072,
    Longitude: -120.5909,
    scale: 4500,
  },
  PA: {
    'Province/State': 'Pennsylvania',
    StateCode: 'PA',
    Latitude: 40.8908,
    Longitude: -77.7098,
    scale: 7000,
  },
  PR: {
    'Province/State': 'Puerto Rico',
    StateCode: 'PR',
    Latitude: 18.2208,
    Longitude: -66.5901,
    scale: 15000,
  },
  RI: {
    'Province/State': 'Rhode Island',
    StateCode: 'RI',
    Latitude: 41.5809,
    Longitude: -71.5118,
    scale: 23000,
  },
  SC: {
    'Province/State': 'South Carolina',
    StateCode: 'SC',
    Latitude: 33.5869,
    Longitude: -80.945,
    scale: 6900,
  },
  SD: {
    'Province/State': 'South Dakota',
    StateCode: 'SD',
    Latitude: 44.2998,
    Longitude: -100.4388,
    scale: 5000,
  },
  TN: {
    'Province/State': 'Tennessee',
    StateCode: 'TN',
    Latitude: 35.7478,
    Longitude: -85.9923,
    scale: 5000,
  },
  TX: {
    'Province/State': 'Texas',
    StateCode: 'TX',
    Latitude: 31.3545,
    Longitude: -99.8635,
    scale: 2500,
  },
  UT: {
    'Province/State': 'Utah',
    StateCode: 'UT',
    Latitude: 39.15,
    Longitude: -111.8624,
  },
  VT: {
    'Province/State': 'Vermont',
    StateCode: 'VT',
    Latitude: 43.9459,
    Longitude: -72.7107,
    scale: 8800,
  },
  VI: {
    'Province/State': 'Virgin Islands, U.S.',
    StateCode: 'VI',
    Latitude: 18.3358,
    Longitude: -64.8963,
  },
  VA: {
    'Province/State': 'Virginia',
    StateCode: 'VA',
    Latitude: 37.7693,
    Longitude: -79.47,
    scale: 5000,
  },
  WA: {
    'Province/State': 'Washington',
    StateCode: 'WA',
    Latitude: 47.4009,
    Longitude: -120.6905,
    scale: 4900,
  },
  WV: {
    'Province/State': 'West Virginia',
    StateCode: 'WV',
    Latitude: 38.8912,
    Longitude: -80.3545,
    scale: 6500,
  },
  WI: {
    'Province/State': 'Wisconsin',
    StateCode: 'WI',
    Latitude: 44.7685,
    Longitude: -89.6165,
    scale: 4500,
  },
  WY: {
    'Province/State': 'Wyoming',
    StateCode: 'WY',
    Latitude: 43.056,
    Longitude: -107.5025,
    scale: 4500,
  },
}
